import { takeEvery, call, all, put } from "redux-saga/effects";
import axios from "axios";
import { StatutoryCommitteeActions } from "./action";
import { API_URL } from "../../utils/Constant";

export const StatutoryCommitteeActionsSagas = function* () {
  yield all([
    takeEvery(
      StatutoryCommitteeActions.GET_STATUTORY_COMMITTEE,
      getStatutoryCommittee
    ),
    takeEvery(
      StatutoryCommitteeActions.GET_STATUTORY_COMMITTEE_SUBPAGE,
      getStatutoryCommitteeSubpage
    ),
  ]);
};

// Main Committee API
const getStatutoryCommittee = function* () {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/institutional_committee`)
    );

    if (result?.data) {
      yield put({
        type: StatutoryCommitteeActions.SET_STATUTORY_COMMITTEE,
        payload: result.data,
      });
    } 

  } catch (error) {
    console.error("Error fetching statutory committee:", error);
  }
};

//  Subpage API
const getStatutoryCommitteeSubpage = function* () {
  try {
    const result = yield call(() => axios.get(`${API_URL}/committees`));

    if (result?.data && Array.isArray(result.data) && result.data.length > 0) {
      yield put({
        type: StatutoryCommitteeActions.SET_STATUTORY_COMMITTEE_SUBPAGE,
        payload: result.data,
      });
      
    }
  } catch (error) {
    console.error("Error fetching statutory committee subpage data:", error);
  }
};
